export default "__VITE_ASSET__V1Yt$R2m__"